<div class="container-fluid h-100 footer">
  <div class="row align-items-center h-100">
    <div class="col-12 text-center text-muted">
      Copyright &copy; 2023 EDT Soft SRL. Todos los derechos reservados.
    </div>
  </div>
</div>
